import { getGeneric } from '../../common/constants'

// PACE → Analytics (PACE+ §2, phase A). Read-only aggregates computed by PACE over
// pace_v2_allocation_result, via the proship relay (/api/allocation/pace-analytics/<view>).
// Filters: merchant_id, since, until (YYYY-MM-DD), mode (LIVE/SHADOW), payment_mode (COD/PREPAID).
const BASE = 'allocation/pace-analytics'

const clean = (f) => Object.fromEntries(Object.entries(f).filter(([, v]) => v !== '' && v != null))

export const fetchAnalytics = (view, filters) => getGeneric(`${BASE}/${view}`, clean(filters))
// file = export.csv (raw columns) | export_business.csv (ops layout, one row per allocation)
export const fetchAnalyticsCsv = (filters, file = 'export.csv') => getGeneric(`${BASE}/${file}`, clean(filters))
